import { CLOUDFARE_TURNSTILE_URL, GOOGLE_URL } from '@shared/constants/paths';

import { CAPTCHA_PROVIDER } from '../constants';

interface CaptchaDisclaimerProps {
  captchaProvider?: string;
  className?: string;
}

const CaptchaDisclaimer = ({ captchaProvider, className }: CaptchaDisclaimerProps) => {
  if (captchaProvider === CAPTCHA_PROVIDER.turnstile) {
    return (
      <p className={className}>
        This site is protected by Cloudflare Turnstile and the Cloudflare{' '}
        <a className="underline" href={CLOUDFARE_TURNSTILE_URL.privacyPolicy} rel="noopener noreferrer" target="_blank">
          Privacy Policy
        </a>{' '}
        apply.
      </p>
    );
  }

  return (
    <p className={className}>
      This site is protected by reCAPTCHA and the Google{' '}
      <a className="underline" href={GOOGLE_URL.privacyPolicy} rel="noopener noreferrer" target="_blank">
        Privacy Policy
      </a>{' '}
      and{' '}
      <a className="underline" href={GOOGLE_URL.termsOfService} rel="noopener noreferrer" target="_blank">
        Terms of Service
      </a>{' '}
      apply.
    </p>
  );
};

export default CaptchaDisclaimer;
